module.exports = __webpack_public_path__ + "static/media/firecro.9f93156a.png";